// ===== Sélection de variante =====
document.addEventListener('DOMContentLoaded', function () {
const cards = document.querySelectorAll('.variant-card');
const idInput = document.getElementById('variant-id');
const addBtn = document.getElementById('add-to-cart-button');

function setActive(card){
cards.forEach(c => c.classList.remove('active'));
card.classList.add('active');

const id = card.getAttribute('data-variant-id');
const priceText = card.getAttribute('data-variant-price');

if (idInput) idInput.value = id;
if (addBtn){
addBtn.textContent = `Ajouter au panier | ${priceText}`;
addBtn.disabled = card.classList.contains('unavailable');
}
}

cards.forEach(card => {
if (!card.classList.contains('unavailable')){
card.addEventListener('click', () => setActive(card));
}
});

const initial = document.querySelector('.variant-card.active') || cards[0];
if (initial) setActive(initial);
});

document.addEventListener('DOMContentLoaded', function () {
const form = document.getElementById('product-form');
const addBtn = document.getElementById('add-to-cart-button');
if (!form || !addBtn) return;
let pending = false;

form.addEventListener('submit', async function (event) {
event.preventDefault();
if (pending || addBtn.disabled) return;
const variantId = form.querySelector('[name="id"]').value;
const originalText = addBtn.textContent;
const cartDrawer = document.querySelector('cart-drawer');
const root = window.Shopify?.routes?.root || '/';
const cartUrl = window.routes?.cart_url || root + 'cart';
const sectionIds = cartDrawer?.getSectionsToRender?.().map(section => section.id) || [];
const payload = { id: variantId, quantity: 1 };
if (sectionIds.length) {
payload.sections = sectionIds;
payload.sections_url = window.location.pathname;
cartDrawer.setActiveElement?.(addBtn);
}
form.querySelector('[data-cart-error]')?.remove();
pending = true;
addBtn.disabled = true;
addBtn.setAttribute('aria-busy', 'true');
addBtn.textContent = 'Ajout en cours...';
let added = false;

try {
const response = await fetch(window.routes?.cart_add_url || root + 'cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify(payload)
});
const data = await response.json();
if (!response.ok || data.status) {
throw new Error(data.description || "Impossible d'ajouter l'article au panier.");
}
added = true;
if (!cartDrawer?.renderContents || !sectionIds.length ||
!sectionIds.every(id => typeof data.sections?.[id] === 'string')) {
window.location.assign(cartUrl);
return;
}
cartDrawer.classList.remove('is-empty');
cartDrawer.renderContents(data);
if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
publish(PUB_SUB_EVENTS.cartUpdate, {
source: 'product-form',
productVariantId: variantId,
cartData: data
});
}
} catch (error) {
if (added) {
window.location.assign(cartUrl);
return;
}
const message = document.createElement('div');
message.dataset.cartError = '';
message.setAttribute('role', 'alert');
message.textContent = error.message || "Impossible d'ajouter l'article au panier.";
message.style.cssText = 'color:#b42318;font-size:14px;margin-top:10px;text-align:center;';
form.appendChild(message);
} finally {
pending = false;
addBtn.removeAttribute('aria-busy');
const selectedCard = document.querySelector('.variant-card.active');
addBtn.disabled = selectedCard ? selectedCard.classList.contains('unavailable') : false;
addBtn.textContent = selectedCard
? 'Ajouter au panier | ' + selectedCard.getAttribute('data-variant-price')
: originalText;
}
});
});

// ===== Countdown livraison =====
(function() {
const countdownEl = document.getElementById("countdown-text");
if(!countdownEl) return;

const now = new Date();
const deadline = new Date();
deadline.setHours(14, 0, 0, 0);

if (now >= deadline) {
countdownEl.innerText = "⏳ Commandez maintenant pour livraison rapide.";
return;
}

function updateCountdown() {
const now = new Date();
const diff = deadline - now;
if (diff <= 0) {
countdownEl.innerText = "⏳ Commandez maintenant pour livraison rapide.";
return;
}

const hours = Math.floor(diff / (1000 * 60 * 60));
const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
countdownEl.innerHTML = `⏳ Commandez dans les <span style="color:#2F7759;font-weight:700;">${hours}h ${minutes}min</span>`;
}

updateCountdown();
setInterval(updateCountdown, 60000);
})();